import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { observer } from "mobx-react";
import { _x, __ } from "../../../../utils";
import { Row, Col, Card, Collapse, Switch, App } from "antd";
import { LinkShortcodeForm, ShortCodeMenuList } from ".";
import { useConfigHintText } from "../../../../hooks";
import { useStores } from "../../../../store";
import { useProModalStickyLinks } from "../../../customize";
const { Panel } = Collapse;
const ShortcodeCards = observer(()=>{
    const hintText = useConfigHintText("shortcodes");
    const { optionStore } = useStores();
    const { busySettings, isBannerStickyLinksEnabled, others: { customizeBannerUrl } } = optionStore;
    const { isPro, modal, tag } = useProModalStickyLinks();
    const { message } = App.useApp();
    const handleToggleBannerStickyLinks = useCallback((status)=>{
        optionStore.updateSettings({
            isBannerStickyLinksEnabled: status
        }).then(()=>{
            message.success(status ? __("Sticky legal links are now enabled on your website") : __("Sticky legal links are now disabled on your website"));
        });
    }, []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            modal,
            /*#__PURE__*/ _jsxs(Collapse, {
                defaultActiveKey: [
                    "nav",
                    "sticky"
                ],
                ghost: true,
                children: [
                    /*#__PURE__*/ _jsx(Panel, {
                        header: /*#__PURE__*/ _jsx("a", {
                            children: __("Add links to existing menu")
                        }),
                        children: /*#__PURE__*/ _jsx(Card, {
                            style: {
                                margin: 5
                            },
                            children: /*#__PURE__*/ _jsx(ShortCodeMenuList, {})
                        })
                    }, "nav"),
                    /*#__PURE__*/ _jsx(Panel, {
                        header: /*#__PURE__*/ _jsx("a", {
                            children: __("Sticky legal links widget")
                        }),
                        children: /*#__PURE__*/ _jsx(Card, {
                            style: {
                                margin: 5
                            },
                            children: /*#__PURE__*/ _jsxs(Row, {
                                align: "middle",
                                children: [
                                    /*#__PURE__*/ _jsxs(Col, {
                                        flex: "auto",
                                        children: [
                                            /*#__PURE__*/ _jsx(Switch, {
                                                loading: busySettings,
                                                onChange: handleToggleBannerStickyLinks,
                                                value: isPro ? isBannerStickyLinksEnabled : false,
                                                disabled: !isPro
                                            }),
                                            "\xa0\xa0",
                                            __("Show a sticky legal links widget on the bottom of your website"),
                                            "\xa0",
                                            tag,
                                            !isPro && /*#__PURE__*/ _jsx("p", {
                                                className: "description",
                                                style: {
                                                    marginTop: 10
                                                },
                                                children: __("You can add the legal links in the free version of Real Cookie Banner as menu items or shortcodes (e.g. in your website footer).")
                                            })
                                        ]
                                    }),
                                    isPro && /*#__PURE__*/ _jsx(Col, {
                                        children: /*#__PURE__*/ _jsx("a", {
                                            href: `${customizeBannerUrl.replace(/autofocus\[panel]=[\w-]+/, `autofocus[section]=real-cookie-banner-banner-sticky-links`)}&return=${encodeURIComponent(window.location.href)}`,
                                            className: "button button-primary",
                                            children: __("Customize")
                                        })
                                    })
                                ]
                            })
                        })
                    }, "sticky"),
                    /*#__PURE__*/ _jsx(Panel, {
                        header: /*#__PURE__*/ _jsx("a", {
                            children: __("Generate shortcode (advanced)")
                        }),
                        children: /*#__PURE__*/ _jsxs(Row, {
                            children: [
                                /*#__PURE__*/ _jsx(Col, {
                                    xl: 8,
                                    sm: 12,
                                    xs: 24,
                                    children: /*#__PURE__*/ _jsx(Card, {
                                        style: {
                                            margin: 5
                                        },
                                        title: _x("Change privacy settings", "legal-text"),
                                        children: /*#__PURE__*/ _jsx(LinkShortcodeForm, {
                                            type: "change"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xl: 8,
                                    sm: 12,
                                    xs: 24,
                                    children: /*#__PURE__*/ _jsx(Card, {
                                        style: {
                                            margin: 5
                                        },
                                        title: _x("Privacy settings history", "legal-text"),
                                        children: /*#__PURE__*/ _jsx(LinkShortcodeForm, {
                                            type: "history"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xl: 8,
                                    sm: 12,
                                    xs: 24,
                                    children: /*#__PURE__*/ _jsx(Card, {
                                        style: {
                                            margin: 5
                                        },
                                        title: _x("Revoke consents", "legal-text"),
                                        children: /*#__PURE__*/ _jsx(LinkShortcodeForm, {
                                            type: "revoke"
                                        })
                                    })
                                })
                            ]
                        })
                    }, "shortcode")
                ]
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "description",
                style: {
                    display: "block",
                    maxWidth: 800,
                    margin: "30px auto 0",
                    textAlign: "center"
                },
                children: hintText
            })
        ]
    });
});
export { ShortcodeCards };
